import { PicklistAssets } from './PicklistAssets';

export default PicklistAssets;
